import { TablePart } from './base.ts';

export class FixedHeader extends TablePart {
  newTable: HTMLTableElement;
  updatePosition: () => void;
  constructor(container, table){
    super(container, table)
    this.fixWidth();
    this.cloneHeader();
    this.listenScrollEvent();
  }
  fixWidth(){
    let ths = this.table.querySelectorAll('th');
    for(let j=0; j< ths.length; j++){
      let th = ths[j];
      $(th).width($(th).width());
    }
  }
  cloneHeader(){
    let newThead = this.table.querySelector('thead').cloneNode(true);
    let tableClass = this.table.getAttribute('class');
    this.newTable = document.createElement('table');
    this.newTable.setAttribute('class', tableClass);
    this.newTable.style.position = 'absolute';
    this.newTable.style.top = '0';
    this.newTable.appendChild(newThead);
    let wrap = document.createElement('div')
    wrap.style.position = 'relative';
    this.table.parentElement.appendChild(wrap);
    wrap.appendChild(this.table);
    wrap.appendChild(this.newTable);
  }
  listenScrollEvent(){
    this.updatePosition = () => {
      let scrollTop = (window.pageYOffset || document.body.scrollTop)  - (document.body.clientTop || 0) || 0;
      let offsetTop = this.container.getBoundingClientRect().top + scrollTop
      let localScrollTop = scrollTop - offsetTop;
      let top = Math.max(localScrollTop, 0);
      this.newTable.style.top = top + 'px';
    }
    window.addEventListener('scroll', this.updatePosition);
    this.updatePosition();
  }
}
